module.exports = __webpack_public_path__ + "images/icons_v2/close-circle-outlined-ca618668.svg";